import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;
const listeners = new Set();

export function clearAccessCache() { cache = null; }

export function useAccess() {
  const [state, setState] = useState(cache);
  useEffect(() => {
    if (cache) { setState(cache); return; }
    const cb = (d) => setState(d);
    listeners.add(cb);
    if (!inflight) {
      inflight = api.get("/access/status").then((r) => {
        cache = r.data;
        listeners.forEach((l) => l(cache));
      }).catch(() => {}).finally(() => { inflight = null; });
    }
    return () => listeners.delete(cb);
  }, []);
  return state || { status: "loading", read_only: false };
}
